import { createContext, useContext, ReactNode } from 'react';
import { useKeyboardScroll } from '../hooks/use-keyboard-scroll';

interface KeyboardScrollContextType {
  scrollToElement: (element: HTMLElement) => void;
}

const KeyboardScrollContext = createContext<KeyboardScrollContextType | undefined>(undefined);

interface KeyboardScrollProviderProps {
  children: ReactNode;
  offset?: number;
  smooth?: boolean;
}

export function KeyboardScrollProvider({
  children,
  offset = 100,
  smooth = true
}: KeyboardScrollProviderProps) {
  const { scrollToElement } = useKeyboardScroll({ offset, smooth });

  return (
    <KeyboardScrollContext.Provider value={{ scrollToElement }}>
      {children}
    </KeyboardScrollContext.Provider>
  );
}

export const useKeyboardScrollContext = () => {
  const context = useContext(KeyboardScrollContext);
  if (context === undefined) {
    throw new Error('useKeyboardScrollContext must be used within a KeyboardScrollProvider');
  }
  return context;
};
